import React, { useEffect, useState } from 'react';
import {
  Content,
  CloseSvg,
  IconContainer,
  ChevronContainer,
  ChevronLeft,
  ChevronRight,
  IconsContainer,
  Delete,
  Background,
  SmallModalContainer,
  ModalTitleSmall,
  ButtonContainerGap,
  StyledButton,
  ButtonText,
} from './ModalComponent.styles';
import Modal from './Modal';
import { Waveform } from '@uiball/loaders';

const GalleryModal = ({ open, onClose, width, height, images, index, deleteLoading, onClickDelete, edit }) => {
  const [openModal, setOpenModal] = useState(false);
  const [isVisible, setIsVisible] = useState(openModal);
  const [currentIndex, setCurrentIndex] = useState('');
  const [imagesArray, setImagesArray] = useState([]);

  useEffect(() => {
    setCurrentIndex(index);
    setImagesArray(images);
  }, [index, images]);

  const handlePrev = () => {
    setCurrentIndex(prevIndex => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'a' || event.key === 'ArrowLeft') {
        handlePrev();
      } else if (event.key === 'd' || event.key === 'ArrowRight') {
        handleNext();
      } else if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    let timer;
    if (openModal) {
      setIsVisible(true);
    } else {
      timer = setTimeout(() => setIsVisible(false), 250);
    }

    return () => clearTimeout(timer);
  }, [openModal]);

  return (
    <Modal isOpen={open} width={width} onClose={onClose} height={height} fade padding={0}>
      <Content imageUrl={imagesArray[currentIndex]?.url}>
        <IconsContainer>
          <IconContainer
            $edit={!edit}
            onClick={() => {
              if (edit) {
                setOpenModal(true);
              }
            }}>
            {edit && <Delete />}
          </IconContainer>

          <IconContainer onClick={onClose}>
            <CloseSvg />
          </IconContainer>
        </IconsContainer>

        <ChevronContainer>
          <IconContainer onClick={handlePrev}>
            <ChevronLeft />
          </IconContainer>

          <IconContainer onClick={handleNext}>
            <ChevronRight />
          </IconContainer>
        </ChevronContainer>
      </Content>
      {isVisible && (
        <>
          <Background $open={openModal} />
          <SmallModalContainer $open={openModal}>
            <ModalTitleSmall style={{ textAlign: 'center' }}>
              Are you sure you want to delete this photo?
            </ModalTitleSmall>
            <ButtonContainerGap style={{ gap: 20 }}>
              <StyledButton onClick={() => setOpenModal(false)}>
                <ButtonText>Cancel</ButtonText>
              </StyledButton>

              <StyledButton
                onClick={() => {
                  if (!deleteLoading) {
                    onClickDelete(imagesArray[currentIndex]?.id);
                    setOpenModal(false);
                    onClose();
                  }
                }}
                $disabled={deleteLoading}
                $black>
                {!deleteLoading ? (
                  <ButtonText $black>Yes</ButtonText>
                ) : (
                  <Waveform size={26} lineWeight={3.5} speed={1} color="white" />
                )}
              </StyledButton>
            </ButtonContainerGap>
          </SmallModalContainer>
        </>
      )}
    </Modal>
  );
};

export default GalleryModal;
